import { orgIdToAri } from '@townsquare/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { AggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { HomeResourceContext } from '@townsquare/router/types';

import WhereYouWorkSectionWithPreloadedQuery, {
	type WhereYouWorkSectionWithPreloadedQuery as WhereYouWorkSectionWithPreloadedQueryType,
} from '../__generated__/WhereYouWorkSectionWithPreloadedQuery.graphql';

export const whereYouWorkResource = createRelayResource<WhereYouWorkSectionWithPreloadedQueryType>({
	getQuery: (_, resourceContext) => {
		const context = resourceContext as HomeResourceContext;
		const accountId = context.user.accountId || '';

		const organisationId = context.workspace?.organisationId ?? context?.orgId ?? '';
		const siteId = (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? '';

		return {
			environment: AggRelayEnvironment,
			query: WhereYouWorkSectionWithPreloadedQuery,
			variables: {
				organizationId: orgIdToAri(organisationId),
				siteId,
				filter: {
					membership: {
						memberIds: [accountId],
					},
				},
				sortBy: [
					{ field: 'IS_VERIFIED', order: 'DESC' },
					{ field: 'DISPLAY_NAME', order: 'ASC' },
				],
				after: null,
				teamId: '', // Default empty, can be overridden
				isTeamSelected: false, // Default false, can be overridden
			},
			cacheKey: `whereYouWorkResource`,
		};
	},
});
